import { hideOverDue, showOverDue } from "./overDueStateActions";
import { CustomerAccount } from "../../../types/types";

export type OverDueStatus = "Initial" | "Show" | "Hide";
export enum DebtCategory {
  ProposedExcluded = 23,
  Other = 22,
}
export enum MaguireDebtCategoryEnum {
  AutoInternalRecovery = 5,
  AutoOverdue = 22,
  AutoProposedExclusion = 3,
}
export function shouldShowOverDue(
  dispatch: any,
  customer: CustomerAccount,
  status: OverDueStatus,
  isMaguireTransitionDay2: boolean
) {
  const isAccountExcluded = isMaguireTransitionDay2 ? customer?.isMaguireExcluded : customer?.isExcluded;

  if (status === "Initial") {
    if (
      isAccountExcluded ||
      (!isMaguireTransitionDay2 && customer?.debtCategoryId === DebtCategory.Other) ||
      (!isMaguireTransitionDay2 && customer?.debtCategoryId === DebtCategory.ProposedExcluded) ||
      (isMaguireTransitionDay2 && customer?.customerAccountDebtCategoryId === MaguireDebtCategoryEnum.AutoOverdue) ||
      (isMaguireTransitionDay2 &&
        customer?.customerAccountDebtCategoryId === MaguireDebtCategoryEnum.AutoProposedExclusion)
    ) {
      dispatch(showOverDue());
    }
  } else if (
    status === "Show" &&
    (isAccountExcluded ||
      (!isMaguireTransitionDay2 && customer?.debtCategoryId === DebtCategory.ProposedExcluded) ||
      (isMaguireTransitionDay2 &&
        customer?.customerAccountDebtCategoryId === MaguireDebtCategoryEnum.AutoProposedExclusion))
  ) {
    dispatch(showOverDue());
  } else {
    dispatch(hideOverDue());
  }
}
